module.exports = __webpack_public_path__ + "img/college_icon0.1a666c9.png";